import { hasSelectedPaymentMethod as hasSelectedPaymentMethodHelper, hasSelectedShippingMethod as hasSelectedShipingMethodHelper, type ShoppingCart } from "@/services/marketplace/cart";

const cart = ref<ShoppingCart>();

export function useCart() {
  const totalQuantity = computed(() => {
    if (cart.value === undefined || cart.value.subcarts.length === 0) {
      return 0;
    }

    let total = 0;
    cart.value.subcarts.map(({ items }) => items.map(({ quantity }) => (total += quantity)));
    return total;
  });

  const isSomethingInCart = computed(() => {
    return totalQuantity.value > 0;
  });

  const hasSelectedPaymentMethod = computed(() => hasSelectedPaymentMethodHelper(cart.value));
  const hasSelectedShipingMethod = computed(() => hasSelectedShipingMethodHelper(cart.value));

  return {
    cart,
    totalQuantity,
    isSomethingInCart,
    hasSelectedPaymentMethod,
    hasSelectedShipingMethod,
  };
}
